import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { FoldersDataService, Folder } from '../folders/folders-data.service';
import { ApiService } from "../../api.service";

@Component({
  selector: 'app-build-ecrf',
  templateUrl: './build-ecrf.component.html',
  styleUrls: ['./build-ecrf.component.scss']
})
export class BuildEcrfComponent implements OnInit {
  ecrfTemplates: any[] = [];
  loading = false;
  newTemplateName: string = '';
  editingTemplateId: number | null = null;
  editedTemplateName: string = '';
  isSidebarVisible: boolean = true;
  defaultFolders: Folder[] = [];

  constructor(
    private router: Router,
    public commonService: CommonService,
    private foldersDataService: FoldersDataService,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.loadDefaultFolders();
    this.loadEcrfTemplates();
  }

  loadDefaultFolders() {
    this.foldersDataService.getFoldersData().subscribe(data => {
      this.defaultFolders = data.folders;
    });
  }

  loadEcrfTemplates() {
    // Load templates from localStorage or API
    // const savedTemplates = localStorage.getItem('ecrfTemplates');
    // if (savedTemplates) {
    //   this.ecrfTemplates = JSON.parse(savedTemplates);
    // }

    console.log("Running Get Templates")
    this.loading = true;
    this.apiService.gettemplates().subscribe(
      response => {
        console.log(response.template);
        this.ecrfTemplates = response.template;
        this.loading = false;
      },
      error => {
        alert(error.message);
        console.log(error.message);
        this.loading = false;
      }
    )
  }

  createNewTemplate() {
    if (this.newTemplateName.trim()) {
      const newTemplate = {
        id: Date.now(),
        name: this.newTemplateName,
        createdAt: new Date().toISOString(),
        folders: this.convertDefaultFoldersToTemplate()
      };
      
      // this.ecrfTemplates.push(newTemplate);
      this.saveTemplates(newTemplate);
      this.newTemplateName = '';
    }
  }

  convertDefaultFoldersToTemplate(): any[] {
    return this.defaultFolders.map(defaultFolder => ({
      id: Date.now() + Math.random(), // Generate unique ID
      name: defaultFolder.name,
      icon: defaultFolder.icon,
      color: defaultFolder.color,
      description: defaultFolder.description,
      title: defaultFolder.title,
      subTitle: defaultFolder.subTitle,
      createdAt: new Date().toISOString(),
      forms: defaultFolder.forms.map(defaultForm => ({
        id: Date.now() + Math.random().toString(36).substring(2,5), // Generate unique ID
        name: defaultForm.name,
        route: defaultForm.route,
        createdAt: new Date().toISOString(),
        fields: defaultForm.fields.map(defaultField => this.convertDefaultFieldToTemplate(defaultField))
      }))
    }));
  }

  convertDefaultFieldToTemplate(defaultField: any): any {
    const fieldName = defaultField.title.toLowerCase().replace(/\s+/g, '_');
    console.log("defaultField", defaultField);
    
    let convertedField: any = {
      title: defaultField.title,
      name: fieldName,
      type: this.mapFieldType(defaultField.type),
      required: defaultField.required,
      description: defaultField.description,
      attachmentRequired: false
    };

    // Handle field-specific properties
    if (defaultField.values && defaultField.values.length > 0) {
      convertedField.options = defaultField.values.map((v: any) => v.label);
    }

    if (defaultField.columns && defaultField.columns.length > 0) {
      convertedField.columns = defaultField.columns;
      console.log(convertedField);
    }

    if (defaultField.unit) {
      convertedField.unit = defaultField.unit;
    }

    // Handle compound fields
    if (defaultField.fields && defaultField.fields.length > 0) {
      convertedField.subFields = defaultField.fields.map((subField: any) => this.convertDefaultFieldToTemplate(subField));
    }
    console.log("convertedField", convertedField);
    return convertedField;
  }

  mapFieldType(defaultType: string): string {
    const typeMapping: { [key: string]: string } = {
      'radio-button': 'radio',
      'dropdown': 'select',
      'date': 'date',
      'time': 'time',
      'number': 'number',
      'textarea': 'textarea',
      'checkbox-group': 'checkbox',
      'calculated': 'calculated',
      'compound': 'compound',
      'signature': 'esignature',
      'table': 'table',
      'title': 'title'
    };

    return typeMapping[defaultType] || 'text';
  }

  openTemplate(template: any) {
    console.log(template);
    this.router.navigate(['/ecrf-template', template.id]);
  }

  deleteTemplate(template: any) {
    if (confirm(`Are you sure you want to delete "${template.name}"?`)) {
      this.ecrfTemplates = this.ecrfTemplates.filter(t => t.id !== template.id);
      localStorage.setItem('ecrfTemplates', JSON.stringify(this.ecrfTemplates));
      this.apiService.deleteTemplate(String(template.id)).subscribe(
        response => {
          this.loadEcrfTemplates();
        }
      )
      // this.saveTemplates(template);
    }
  }

  startEditTemplate(template: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.editingTemplateId = template.id;
    this.editedTemplateName = template.name;
  }

  saveEditTemplate(template: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    const trimmedName = (this.editedTemplateName || '').trim();
    if (!trimmedName) {
      return;
    }
    template.name = trimmedName;
    this.editingTemplateId = null;
    this.editedTemplateName = '';
    this.saveTemplates(template);
  }

  cancelEdit(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.editingTemplateId = null;
    this.editedTemplateName = '';
  }

  toggleSideNav(): void {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  private saveTemplates(template: any) {
    // localStorage.setItem('ecrfTemplates', JSON.stringify(this.ecrfTemplates));
    this.loading = true;
    console.log(template);
    this.apiService.saveTemplates(template).subscribe (
      response => {
        this.loadEcrfTemplates();
        this.loading = false;
      },
      error => {
        console.log(error);
        this.loading = false;
        
        // Show alert with error message from response for 400 status only
        if (error.status === 400) {
          let errorMessage = 'Error saving template.';
          if (error.error) {
            if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            } else if (typeof error.error === 'string') {
              errorMessage = error.error;
            }
          }
          alert(errorMessage);
        }
      }
    )
  }
} 